export const feeRevenueData = {
  total: 125000,
  byService: [
    { service: 'Card Transactions fees', amount: 45000 },
    // { service: 'Card Transactions Percentagefees', amount: 5 },
    { service: 'Bank Transactions fees', amount: 45000 },
    // { service: 'Bank Transactions Percentage', amount: 2.1 },
    { service: 'Identity verification', amount: 15000 },
    { service: 'Fundraiser verification', amount: 8000 },
    { service: 'Fundraiser withdrawal fee', amount: 42000 },
    { service: 'Overdraft Fees', amount: 15000 },
    { service: 'Other Fees', amount: 10000 }
  ],
  overTime: [
    { month: 'Jan', amount: 10000 },
    { month: 'Feb', amount: 12000 },
    { month: 'Mar', amount: 15000 },
    { month: 'Apr', amount: 18000 },
    { month: 'May', amount: 20000 },
    { month: 'Jun', amount: 22000 }
  ]
};

export const subscriptionRevenueData = {
  total: 75000,
  byPlan: [
    { plan: 'Premium', amount: 40000 },
    { plan: 'Business', amount: 25000 },
    { plan: 'Basic', amount: 10000 }
  ],
  overTime: [
    { month: 'Jan', amount: 12000 },
    { month: 'Feb', amount: 14000 },
    { month: 'Mar', amount: 16000 },
    { month: 'Apr', amount: 18000 },
    { month: 'May', amount: 15000 },
    { month: 'Jun', amount: 17000 }
  ],
  churnRate: 0.05, // 5% churn rate
  newSubscriptions: 320
};

export const cardRevenueData = {
  total: 50000,
  byType: [
    { type: 'Interchange', amount: 30000 },
    { type: 'Foreign Transaction', amount: 10000 },
    { type: 'ATM Fees', amount: 5000 },
    { type: 'Other', amount: 5000 }
  ],
  overTime: [
    { month: 'Jan', amount: 8000 },
    { month: 'Feb', amount: 9000 },
    { month: 'Mar', amount: 11000 },
    { month: 'Apr', amount: 12000 },
    { month: 'May', amount: 10000 },
    { month: 'Jun', amount: 11500 }
  ],
  byCardType: [
    { cardType: 'Visa', amount: 20000 },
    { cardType: 'Mastercard', amount: 18000 },
    { cardType: 'Amex', amount: 8000 },
    { cardType: 'Other', amount: 4000 }
  ],
  byBankType: [
    { cardType: 'Visa', amount: 50000 },
    { cardType: 'Mastercard', amount: 48000 },
    { cardType: 'Amex', amount: 8000 },
    { cardType: 'Other', amount: 7000 }
  ]
};

export const paidServicesData = {
  total: 88000,
  byService: [
    { service: 'Financial Advisory', amount: 35000 },
    { service: 'Tax Preparation', amount: 25000 },
    { service: 'Estate Planning', amount: 15000 },
    { service: 'Other Services', amount: 13000 }
  ],
  overTime: [
    { month: 'Jan', amount: 12000 },
    { month: 'Feb', amount: 14000 },
    { month: 'Mar', amount: 15000 },
    { month: 'Apr', amount: 18000 },
    { month: 'May', amount: 16000 },
    { month: 'Jun', amount: 13000 }
  ],
  byClientType: [
    { clientType: 'Individual', amount: 45000 },
    { clientType: 'Small Business', amount: 30000 },
    { clientType: 'Corporate', amount: 13000 }
  ]
};

export const savingsData = {
  total: 2500000,
  byUserType: [
    { userType: 'Personal', balance: 1500000, accounts: 1250 },
    { userType: 'Business', balance: 800000, accounts: 320 },
    { userType: 'Non-Profit', balance: 200000, accounts: 45 }
  ],
  transactions: [
    { id: 1, user: 'John Doe', type: 'Deposit', amount: 5000, date: '2023-05-01' },
    { id: 2, user: 'Jane Smith', type: 'Withdrawal', amount: 2000, date: '2023-05-03' },
    { id: 3, user: 'Acme Corp', type: 'Deposit', amount: 250000, date: '2023-05-05' },
    { id: 4, user: 'John Doe', type: 'Interest', amount: 150, date: '2023-05-10' },
    { id: 5, user: 'City Library', type: 'Deposit', amount: 50000, date: '2023-05-15' }
  ],
  interestRates: {
    personal: 0.015, // 1.5%
    business: 0.01,   // 1.0%
    nonProfit: 0.02   // 2.0%
  }
};